<script>
import DraggableResizeMixin from '@/mixins/draggableResizeMixin.js';

export default {
  name: 'XzTable',
  mixins: [DraggableResizeMixin],
  props: {
    // 是否开启嵌套表格
    isNest: {
      type: Boolean,
      default: false,
    },
    // 展开行的key值数组
    expandedRowKeys: {
      type: Array,
      default: () => ([]),
    },
    toolbarConfig: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    styleAttrs: {
      type: Object,
      default: () => ({
        backgroundColor: '#ffffff',
      }),
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: [String, Function],
      default: (record, index) => index,
    },
    searchAttrs: {
      type: Object,
      default: () => ({
        show: false,
        placeholder: '请输入',
      }),
    },
    searchVal: {
      type: String,
      default: '',
    },
    searchAllowClear: {
      type: Boolean,
      default: false,
    },
    toolsAttrs: {
      type: Object,
      default: () => ({
        advancedSearch: false,
      }),
    },
    showPagination: {
      type: [Boolean, Object],
      default: false,
    },
    maskClosable: {
      type: Boolean,
      default: true,
    },
    drawerWidth: {
      type: Number,
      default: 400,
    },
    drawerStyle: {
      type: Object,
      default: () => ({
        display: 'flex',
        flexDirection: 'column',
      }),
    },
    bodyStyle: {
      type: Object,
      default: () => ({
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }),
    },
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    enableRowSelection: {
      type: Boolean,
      default: false,
    },
    selectionType: {
      type: String,
      default: 'checkbox',
    },
    locale: {
      type: Object,
    },
    aSlotsKey: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedRowKeys: {
      type: Array,
      default: () => ([]),
    },
    getCheckboxProps: {
      type: Function,
      default: null,
    },
  },
  render () {
    const on = {
      ...this.$listeners,
    };
    const props = { ...this.$attrs, ...this.$props, ...{ dataSource: this.data, columns: this.columns } };

    if (!props.locale) {
      const emptyImg = require('@/assets/empty.svg');

      props.locale = {
        emptyText: () => <a-empty image={emptyImg} description={'暂无数据'}></a-empty>,
      };
    }

    const buttonSlots = this.$slots['buttons'];
    const otherSlots = this.$slots['others'];

    const aSlots = this.aSlotsKey.map(key => <span slot={key}>{this.$slots[key]}</span>);

    const search = [];
    if (this.searchAttrs.show) {
      search.push(
        <a-input-search
          value={this.searchVal}
          placeholder={this.searchAttrs.placeholder}
          style="width: 260px; margin-left: 8px;"
          allowClear={this.searchAllowClear}
          onChange={this.handleSearchChange.bind(this)}
          onSearch={this.handleSearch.bind(this)}
        />,
      );
    }

    const tools = [];
    let drawer = null;
    if (this.toolsAttrs.advancedSearch) {
      tools.push(
        <el-button onClick={this.handleDrawer.bind(this, true)} class="tools-button">
          <img src={ this.isSearch ? require('@/assets/adSearch_checked.svg') : require('@/assets/adSearch.svg')} class="icon" />
        </el-button>,
      );

      drawer = (
        <a-drawer
          title="高级筛选"
          closable={true}
          width={this.drawerWidth}
          drawerStyle={this.drawerStyle}
          bodyStyle={this.bodyStyle}
          visible={this.drawerVisible}
          maskClosable={this.maskClosable}
          onClose={this.handleDrawer.bind(this, false)}
        >
          {this.$slots['drawer']}
        </a-drawer>
      );
    }

    if (this.toolsAttrs.zoom) {
      if (this.toolsAttrs.fullScreen) {
        tools.push(<el-button onClick={this.handleDetailFullScreen.bind(this, false)} class="tools-button"><img src={require('@/assets/ic_zhankai.svg')} class="icon"/></el-button>);
      } else {
        tools.push(<el-button onClick={this.handleDetailFullScreen.bind(this, true)} class="tools-button"><img src={require('@/assets/ic_shouqi.svg')} class="icon"/></el-button>);
      }
    }

    if (this.toolsAttrs.refresh) {
      tools.push(<el-button onClick={this.handleRefresh.bind(this, true)} class="tools-button"><img src={require('@/assets/ic_refresh.svg')} class="icon"/></el-button>);
    }

    if (this.toolsAttrs.custom) {
      let custom = this.$slots['custom'];
      tools.push(custom);
    }

    let rowSelection = null;
    if (this.enableRowSelection) {
      rowSelection = {
        columnWidth: 50,
        fixed: true,
        type: this.selectionType,
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, rows) => {
          this.selectedRows = this.selectedRows.concat(rows);
          this.selectedRows = this.selectedRows.filter(item => selectedRowKeys.indexOf(item[this.rowKey]) !== -1);
          // 数组对象去重
          let map = new Map();
          for (let item of this.selectedRows) {
            if (!map.has(item[this.rowKey])) {
              map.set(item[this.rowKey], item);
            }
          }
          this.selectedRows = [...map.values()];
          this.handleSelectChange(selectedRowKeys, this.selectedRows);
        },
      };
      if (this.getCheckboxProps) {
        rowSelection.getCheckboxProps = this.getCheckboxProps;
      }
    }

    // 创建自定义图标
    const expandIcon = (props) => {
      // 如果是子表格，则显示展开图标
      if (!this.isNest) {
        return null;
      }

      return (
        <img
          onClick={() => this.toggleExpand(props.record.id, props.record)}
          src={this.expandedRowKeys.includes(props.record.id) ? this.minusSquareIcon : this.plusSquareIcon}
          style={{ width: '18px', height: '18px' }}
        />
      );
    };

    const table = (
      <a-table
        ref="aTable"
        class={props.editable ? 'editable' : ''}
        props={props}
        scopedSlots={this.$scopedSlots}
        on={on}
        style={this.styleAttrs}
        pagination={this.showPagination}
        rowSelection={rowSelection}
        components={this.components}
        rowKey={record => record[this.rowKey]}
        expandIcon={expandIcon}
      >
        {aSlots}
      </a-table>
    );
    return (
      <div class="xz-table-wrapper" >
        <div class="slot-wrapper">
          <div class="button-wrapper">{buttonSlots}</div>
          <div class="default">
            {otherSlots}
            {search}
            {tools}
          </div>
        </div>
        <div class="xz-table">{table}</div>
        {drawer}
      </div>
    );
  },
  data () {
    return {
      minusSquareIcon: require('@/assets/minus-square.png'),
      plusSquareIcon: require('@/assets/plus-square.png'),
      selectedRows: [],
    };
  },
  watch: {
    expandedRowKeys: {
      handler (newVal) {
        this.$nextTick(() => {
          this.$emit('update:expandedRowKeys', newVal);
          // 查找所有.expand-icon-all元素
          const expandIconAlls = document.querySelectorAll('.expand-icon-all');
          if (expandIconAlls.length) {
            let currentIcon = null;
            if (newVal.length) {
              currentIcon = this.minusSquareIcon;
            } else {
              currentIcon = this.plusSquareIcon;
            }

            for (let i = 0; i < expandIconAlls.length; i++) {
              expandIconAlls[i].src = currentIcon;
            }
          }
        });
      },
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.addElementsToClass();
    });
  },
  methods: {
    // 全部展开/收起
    openCloseAll () {
      this.$nextTick(() => {
        if (this.expandedRowKeys.length) {
          this.$emit('update:expandedRowKeys', []);
        } else {
          this.$emit('update:expandedRowKeys', this.data.map(item => item[this.rowKey]));
        }
        this.$emit('openCloseAll');
      });
    },

    toggleExpand (key, record) {
      if (this.expandedRowKeys.includes(key)) {
        this.$emit('update:expandedRowKeys', this.expandedRowKeys.filter(k => k !== key));
      } else {
        this.$emit('update:expandedRowKeys', [...this.expandedRowKeys, key]);
      }
      this.$emit('expand', key, record);
    },

    addElementsToClass () {
      const expandIcons = document.querySelectorAll('.ant-table-expand-icon-th');
      expandIcons.forEach(icon => {
        if (!icon.querySelector('.expand-icon-all')) {
          const newElement = document.createElement('img');
          newElement.classList.add('expand-icon-all');
          newElement.src = this.plusSquareIcon;
          newElement.style.width = '18px';
          newElement.style.height = '18px';
          newElement.onclick = () => {
            this.openCloseAll();
          };
          icon.appendChild(newElement);
        }
      });

      // 删除ant-table-fixed-right下的所有expand-icon-all元素
      const fixedRightExpandIcons = document.querySelectorAll('.ant-table-fixed-right .expand-icon-all');
      fixedRightExpandIcons.forEach(icon => {
        icon.remove();
      });
    },
    handleSearchChange (e) {
      this.$emit('update:searchVal', e.target.value);
    },
    handleSearch (v) {
      this.$emit('search', v);
    },
    handleDrawer (v) {
      this.$emit('update:drawerVisible', v);
    },
    handleSelectChange (keys, rows) {
      this.$emit('change', keys, rows);
    },
    handleRefresh () {
      this.$emit('refresh');
    },
    handleDetailFullScreen (flag) {
      this.$emit('fullScreen', flag);
    },
  },
};
</script>
<style scoped lang="scss">
.xz-table-wrapper {
  height: 100%;

  .tools-button {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 16px;
      height: 16px;
    }
  }

  .slot-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .button-wrapper {
      button {
        margin-right: 12px;
      }
    }

    .default {
      flex: 1;
      text-align: right;

      button {
        margin-left: 8px;
        padding: 9px;
        width: 32px;
        height: 32px;
        &:first-of-type {
          margin-left: 16px;
        }
      }
    }
  }

  .editable {
    /deep/ .ant-form-item {
      margin: 0;

      .ant-form-explain {
        display: none;
      }
    }

    /deep/ .ant-table-tbody > tr > td {
      padding: 0 16px 0;
      overflow-wrap: break-word;
    }
  }

  /deep/ .ant-table-thead {
    & > tr > th {
      padding: 9px 16px;
      font-weight: bold;
      background-color: #f2f4f7;
    }
  }

  /deep/ .ant-table-tbody {
    tr {
      background-color: #fff;

      & > td {
        padding: 9px 16px;
        border-bottom-color: #ebedf0;
      }
    }
  }

  /deep/ .ant-table-fixed-right {
    .ant-table-body-outer {
      padding-right: 0 !important;
    }

    .ant-table-thead {
      & > tr > th {
        padding: 9px 16px;
        font-weight: bold;
      }
    }

    .ant-table-tbody {
      tr {
        background-color: #fff;

        & > td {
          padding: 9px 16px;
          border-bottom-color: #ebedf0;
        }
      }
    }
  }
  /deep/ .ant-table-body-inner {
    padding-bottom: 8px;
  }
}

/deep/.ant-drawer-content .ant-drawer-body {
  padding: 16px;
}

.subTableSelect {
  margin-left: 50px;
}
</style>
